export const adminRoles = {
    admin: "ADMIN_USER",
    super_admin: "SUPER_ADMIN",
    reseller: "RESELLER_USER"
}